// extracted by mini-css-extract-plugin
export default {"pageLayout":"BiopharmaGroupsStats-module__pageLayout___pHd4s"};